module.exports = __webpack_public_path__ + "static/media/circle-plus.fc78274f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/circle-plus.svg
// module id = 7674
// module chunks = 0